import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import styles from './HelpText.module.css';
import type { HelpTextProps } from './HelpText.types';
const HelpText = t0 => {
  const $ = _c(20);
  let children;
  let id;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      ariaLiveMode: t1,
      children,
      disabled: t2,
      error: t3,
      id,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = id;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    children = $[1];
    id = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  const ariaLiveMode = t1 === undefined ? "off" : t1;
  const disabled = t2 === undefined ? false : t2;
  const error = t3 === undefined ? false : t3;
  let t4;
  if ($[7] !== disabled || $[8] !== error) {
    t4 = clsx(styles.helpText, {
      [styles.error]: error,
      [styles.disabled]: disabled
    });
    $[7] = disabled;
    $[8] = error;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const className = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      assertive: "alert",
      polite: "status",
      off: "none"
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const urgency = t5;
  const descriptor = error ? "error" : "help";
  const t6 = `${id}-${descriptor}`;
  const t7 = `${id}-${descriptor}`;
  const t8 = urgency[ariaLiveMode];
  const t9 = ariaLiveMode !== "off";
  let t10;
  if ($[11] !== ariaLiveMode || $[12] !== children || $[13] !== className || $[14] !== props || $[15] !== t6 || $[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t10 = <p id={t6} className={className} data-test-id={t7} aria-live={ariaLiveMode} role={t8} aria-atomic={t9} {...props}>{children}</p>;
    $[11] = ariaLiveMode;
    $[12] = children;
    $[13] = className;
    $[14] = props;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
export { HelpText };